import React from 'react';
import useStyle from './challengesList.style';
import { PedagogicalChallengesButton } from 'components/molecules/Buttons/PedagogicalChallengesButton';
import { DefisList } from 'graphql/generated/graphql';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { trackEvent } from '../../../services/matomo/trackEvent';

interface ChallengesListProps {
  goToSinglePedagogicalChallenge: (id: number) => void;
  list: DefisList[];
}

export const ChallengesList = ({
  goToSinglePedagogicalChallenge,
  list
}: ChallengesListProps) => {
  const classes = useStyle();
  const futurEvents: DefisList[] = [];
  const passedEvents: DefisList[] = [];

  const now = new Date();

  list.length > 0 &&
    list.forEach(element => {
      const endDate = new Date(element.fin);
      endDate > now ? futurEvents.push(element) : passedEvents.push(element);
    });

  futurEvents.sort((a, b) => {
    const endDateA = new Date(a.fin);
    const endDateB = new Date(b.fin);
    return endDateA.getTime() - endDateB.getTime();
  });

  return (
    <div className={classes.root}>
      <p>En cours / à venir :</p>
      {futurEvents.length > 0 ? (
        futurEvents.map((element, index) => (
          <PedagogicalChallengesButton
            key={index}
            variant="default"
            name={element.name}
            startDate={element.debut}
            endDate={element.fin}
            onClick={() => {
              goToSinglePedagogicalChallenge(parseInt(element.id));
              trackEvent('Défi', 'en cours / à venir', element.name);
            }}
          />
        ))
      ) : (
        <FeatureContainer>
          <p>
            Aucun défi en cours{' '}
            <span role="img" aria-label="Smiley qui dort">
              😴
            </span>
          </p>
        </FeatureContainer>
      )}
      {passedEvents.length > 0 && (
        <>
          <p>Terminés :</p>
          {passedEvents.map((element, index) => (
            <PedagogicalChallengesButton
              key={index}
              variant="finished"
              name={element.name}
              startDate={element.debut}
              endDate={element.fin}
              onClick={() => {
                goToSinglePedagogicalChallenge(parseInt(element.id));
                trackEvent('Défi', 'terminé', element.name);
              }}
            />
          ))}
        </>
      )}
    </div>
  );
};
